// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9":"Contact","274":"Home","450":"About","549":"Policy","756":"Events"}[chunkId] + "." + {"9":"1e06c533","274":"80c6f82c","450":"79a22a4d","549":"369e015b","756":"c2512f0c"}[chunkId] + ".chunk.css";
};